import { IoArrowBack } from 'react-icons/io5';

import { UnstyledButton } from '@mantine/core';

import { InlineFilters } from 'components/component-overview/inline-filters/InlineFilters';
import { SearchService } from 'components/component-overview/services/SearchService';

const InlineFiltersBack = () => {
    return (
        <UnstyledButton onClick={SearchService.resetHasSearched}>
            <InlineFilters.Section
                label={<IoArrowBack style={{ marginTop: 5 }} />}
                body="Back to overview"
                active={false}
            />
        </UnstyledButton>
    );
};

export { InlineFiltersBack };
